<template>
  <div ref="modalbox">
    <a-modal
      v-model="show"
      :centered="true"
      :keyboard="false"
      :footer="null"
      :width="1100"
      :bodyStyle="bodyStyle"
      :closable="false"
      :getContainer="() => this.$refs.modalbox"
    >
      <div class="headbox">
        <span>告警记录</span>
        <a-icon class="iconbtn" type="close" @click="close" />
      </div>
      <a-tabs :activeKey="activeKey" @change="callback">
        <a-tab-pane tab="工商系统式" key="0"></a-tab-pane>
        <a-tab-pane tab="工商业独立式" key="2"></a-tab-pane>
        <a-tab-pane tab="家用" key="1"></a-tab-pane>
      </a-tabs>
      <!-- 表格区域 -->
      <a-table
        ref="TableInfo"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="pagination"
        :loading="loading"
        :scroll="{ x: 800 }"
        :row-selection="rowSelection"
        @change="handleTableChange"
      >
        <template slot="operation" slot-scope="text, record">
          <!-- <a-icon class="iconbtn"
                  v-hasPermission="'alarmRecordIndustry:clearRecord'"
                  type="control"
                  theme="twoTone"
                  @click="onCheck(record)"
                  title="操作"></a-icon> -->
          <a
            href="javascript:;"
            v-hasPermission="'alarmRecordIndustry:clearRecord'"
            @click="onCheck(record)"
            >操作</a
          >
          <span
            v-hasNoPermission="'alarmRecordIndustry:clearRecord'"
            style="color: #fff"
            >无权限</span
          >
        </template>
      </a-table>
      <a-button
        v-hasPermission="'alarmRecordIndustry:clearRecord'"
        :disabled="!selectedRowKeys.length"
        type="primary"
        @click="onClear"
        >清除记录</a-button
      >

      <edit-record-modal
        :visible="recordModalVisible"
        :checkData="checkData"
        @onEditHide="onEditHide"
        @onEditOk="onEditOk"
      />

      <password-validation-modal
        :visible="passwordModalVisible"
        :checkNum="checkNum"
        @onPasswordHide="onPasswordHide"
        @onPasswordOk="onPasswordOk"
      />
    </a-modal>
  </div>
</template>

<script>
const formItemLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 18 },
};
import monitorType from "../business/monitor/monitorType";
import editRecordModal from "../../components/modals/editrecordmodal.vue";
import passwordValidationModal from "../../components/modals/passwordvalidationmodal";
export default {
  name: "AlarmRecord",
  components: { editRecordModal, passwordValidationModal },
  data() {
    return {
      formItemLayout,
      recordModalVisible: false,
      passwordModalVisible: false,
      checkNum: 1,
      form: this.$form.createForm(this),
      selectedRowKeys: [],
      loading: false,
      pagination: {
        pageSizeOptions: ["10", "20", "30", "40", "100"],
        defaultCurrent: 1,
        defaultPageSize: 10,
        // showQuickJumper: true,
        // showSizeChanger: true,
        showTotal: (total, range) =>
          `显示 ${range[0]} ~ ${range[1]} 条记录，共 ${total} 条记录`,
      },
      dataSource: [],
      activeKey: "0",
      bodyStyle: {
        "padding-top": 0,
        "margin-top": "-10px",
      },
      clearReason: "",
      clearId: "",
      checkData: {},
    };
  },
  props: {
    alarmRecordVisiable: {
      require: true,
      default: false,
    },
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
      };
    },
    show: {
      get: function () {
        return this.alarmRecordVisiable;
      },
      set: function () {},
    },
    columns() {
      let self = this;
      let columns = [
        {
          title: "区域名称",
          className: "columndata",
          dataIndex: "areaName",
        },
        {
          title: "IMEI码",
          className: "columndata",
          dataIndex: "imei",
        },
        {
          title: "报警器类型",
          className: "columndata",
          dataIndex: "alarmTypeName",
        },
        {
          title: "探测器编号",
          className: "columndata",
          dataIndex: "detectorNumber",
        },
        {
          title: "报警类型",
          className: "columndata",
          dataIndex: "alarmEventType",
          customRender: (text, record) => {
            let arr =
              this.activeKey === "0"
                ? monitorType.commerceEvent
                : this.activeKey === "1"
                ? monitorType.householdEvent
                : monitorType.commerceRestaurantEvent;
            let index = arr.findIndex((item) => {
              return item.value == text;
            });
            return index > -1 ? `${arr[index].name}` : "";
          },
        },
        /* {
          title: "气体浓度",
          key: "concentration",
          className: "columndata",
          dataIndex: "concentration",
        }, */
        {
          title: "报警时间",
          className: "columndata",
          dataIndex: "createTime",
        },
        {
          title: "结束时间",
          className: "columndata",
          dataIndex: "modifyTime",
        },
        {
          title: "操作",
          dataIndex: "operation",
          className: "columndata",
          scopedSlots: { customRender: "operation" },
        },
      ];
      if (this.activeKey != 0) {
        columns.splice(3, 1);
      }
      return columns;
    },
  },
  watch: {
    alarmRecordVisiable() {
      if (this.alarmRecordVisiable) {
        this.getData();
      }
    },
  },
  methods: {
    onSelectChange(selectedRowKeys) {
      console.log("selectedRowKeys changed: ", selectedRowKeys);
      this.selectedRowKeys = selectedRowKeys;
      this.checkNum = selectedRowKeys.length;
    },
    callback(key) {
      this.activeKey = key;
      this.selectedRowKeys = [];
      if (this.paginationInfo) {
        this.paginationInfo.current = 1;
      }
      this.getData();
    },
    handleTableChange(pagination, filters, sorter) {
      // 将这三个参数赋值给Vue data，用于后续使用
      this.paginationInfo = pagination;
      this.filteredInfo = filters;
      this.sortedInfo = sorter;

      this.getData({
        sortField: sorter.field,
        sortOrder: sorter.order,
        ...filters,
      });
    },
    getData(params = {}) {
      this.loading = true;
      if (this.paginationInfo) {
        // 如果分页信息不为空，则设置表格当前第几页，每页条数，并设置查询分页参数
        this.$refs.TableInfo.pagination.current = this.paginationInfo.current;
        this.$refs.TableInfo.pagination.pageSize = this.paginationInfo.pageSize;
        params.pageSize = this.paginationInfo.pageSize;
        params.pageNum = this.paginationInfo.current;
      } else {
        // 如果分页信息为空，则设置为默认值
        params.pageSize = this.pagination.defaultPageSize;
        params.pageNum = this.pagination.defaultCurrent;
      }
      this.$get(
        this.activeKey === "0"
          ? "alarm-record-industry"
          : this.activeKey === "1"
          ? "alarm-record-hosehold"
          : "alarm-record-restaurant",
        {
          ...params,
          isClear: false,
        }
      )
        .then((res) => {
          console.log(res);
          this.dataSource = res.data.rows;
          const pagination = { ...this.pagination };
          pagination.total = res.data.total;
          this.pagination = pagination;

          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    close() {
      this.$emit("close");
    },
    onCheck(record) {
      this.recordModalVisible = true;
      this.clearId = record.id;
      this.selectedRowKeys = [];
      this.checkData = record;
      this.checkNum = 1;
    },
    onEditHide() {
      this.recordModalVisible = false;
    },
    onEditOk(clearReason) {
      console.log("clearOk", clearReason);
      this.passwordModalVisible = true;
      this.clearReason = clearReason;
    },
    onClear() {
      this.passwordModalVisible = true;
    },
    onPasswordOk(password) {
      let clearIds = [];
      for (let key of this.selectedRowKeys) {
        clearIds.push(this.dataSource[key].id);
      }
      let ids;
      let clearReason;
      if (!this.selectedRowKeys.length) {
        ids = this.clearId;
        clearReason = this.clearReason;
      } else {
        ids = clearIds.join(",");
        clearReason = 1;
      }
      console.log("清除", { ids, password, clearReason });
      this.$post(
        this.activeKey === "1"
          ? "alarm-record-hosehold/clearAlarmRecordList"
          : this.activeKey === "0"
          ? "alarm-record-industry/clearAlarmRecordList"
          : "alarm-record-restaurant/clearAlarmRecordList",
        { ids, password, clearReason }
      ).then((res) => {
        this.passwordModalVisible = false;
        this.recordModalVisible = false;
        this.getData();
        this.selectedRowKeys = [];
        console.log(res.data.message);
        if (res.data.row) {
          this.$notification.error({
            message: "系统提示",
            description: res.data.message,
            duration: 4,
          });
        } else {
          this.$notification.success({
            message: "系统提示",
            description: res.data.message,
            duration: 4,
          });
        }
      });
    },
    onPasswordHide() {
      this.passwordModalVisible = false;
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .ant-pagination-item-link {
  background-color: rgba(5, 51, 143, 0.898) !important;
  border: none !important;
  color: white !important;
  font-size: 0.6vw !important;
  i {
    font-size: 0.4vw !important;
  }
}
/deep/ .ant-pagination-item {
  background-color: rgba(5, 51, 143, 0.898);
}
/deep/ .ant-pagination-item a {
  color: white;
  font-size: 0.6vw;
}
/deep/ .columndata,
/deep/ .ant-table-selection-column {
  background-color: rgb(36, 35, 35) !important;
  color: #fff !important;
  font-size: 0.7vw;
}
/deep/ .ant-tabs-ink-bar {
  height: 5px;
}
/deep/ .ant-modal-content,
/deep/ .ant-modal-header {
  border-bottom: 0;
  background-color: rgba(0, 51, 153, 0.898039215686275) !important;
  width: 50vw;
  padding: 0.4vw 0.6vw;
}
/deep/ .ant-table-pagination.ant-pagination {
  margin: 0.6vw;
}
/deep/ .ant-modal-content {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
/deep/ .ant-modal-title {
  font-size: #fff !important;
}
/deep/ .ant-pagination-total-text {
  color: #fff !important;
  font-size: 0.55vw;
}
/deep/ .ant-table-placeholder {
  background-color: rgb(36, 35, 35) !important;
  color: white;
  font-size: 0.6vw;
}
/deep/ .ant-tabs-tab {
  color: white !important;
  font-size: 0.7vw;
}
.headbox {
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  margin-left: 0.5vw;
  height: 5vh;
  font-size: 0.8vw;
  // background-color: #fff;
  position: relative;
  &::before {
    content: "";
    display: block;
    width: 0.2vw;
    height: 1.7vh;
    background-color: dodgerblue;
    position: absolute;
    left: -0.3vw;
    top: 50%;
    transform: translateY(-50%);
  }
}
.iconbtn:hover {
  cursor: pointer;
  font-size: 0.6vw;
}
.iconbtn {
  font-size: 0.6vw;
}
/* .clearBtn{
  font-size: 0.6vw !important;
  width: 4vw;
  height: 2.1vw;
  text-align: center;
} */
</style>



// WEBPACK FOOTER //
// src/views/bigscreen/AlarmRecordNow.vue